import * as React from "react"
import colorHelper from "@digits-shared/helpers/colorHelper"
import colors from "@digits-shared/themes/colors"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { type SliderProps } from "@radix-ui/react-slider"
import styled from "styled-components"

const Slider = styled(SliderPrimitive.Slider)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
  height: 20px;
`

const SliderTrack = styled(SliderPrimitive.Track)<{ $trackColor: string }>`
  background-color: ${({ $trackColor }) => $trackColor};
  position: relative;
  flex-grow: 1;
  border-radius: 9999px;
  height: 3px;
`

const SliderRange = styled(SliderPrimitive.Range)<{ $rangeColor: string }>`
  position: absolute;
  background-color: ${({ $rangeColor }) => $rangeColor};
  border-radius: 9999px;
  height: 100%;
`

const SliderThumb = styled(SliderPrimitive.SliderThumb)<{ $thumbColor: string }>`
  display: block;
  width: 16px;
  height: 16px;
  background-color: ${({ $thumbColor }) => $thumbColor};
  border-radius: 50%;
  cursor: pointer;

  &:hover,
  &:focus {
    outline: 6px solid ${({ $thumbColor }) => colorHelper.hexToRgba($thumbColor, 0.2)};
  }
`

interface CustomProps {
  trackColor?: string
  rangeColor?: string
  thumbColor?: string
}

export const MinMaxSlider: React.FCWithRef<HTMLSpanElement, SliderProps & CustomProps> = ({
  ref,
  trackColor = colors.white,
  rangeColor = "#94b0f2",
  thumbColor = colors.accentBlue,
  minStepsBetweenThumbs,
  ...props
}) => {
  const value = props.value || props.defaultValue || [0, 100]

  return (
    <Slider minStepsBetweenThumbs={minStepsBetweenThumbs} ref={ref} {...props}>
      <SliderTrack $trackColor={trackColor}>
        <SliderRange $rangeColor={rangeColor} />
      </SliderTrack>
      {value.map((_, i) => (
        <SliderThumb key={i} $thumbColor={thumbColor} />
      ))}
    </Slider>
  )
}
